import packageInfo from '../../package.json';

export const environment = {
    production: false,
    host: 'https://api.brawlionjoyeria.com/',
    version: packageInfo.version,
};
